//Please add the language resource
const driver = {
  driverName: 'driverName',
  idCard: 'idCard',
  mobile: 'mobile',
  companyCode: 'companyCode',
  companyName: 'companyName',
  carrierCode: 'carrierCode',
  carrierName: 'carrierName',
  createTime: 'createTime',
  creator: 'creator',
  updateTime: 'updateTime',
  updater: 'updater',

  company: 'company',
  useCompanyName: 'useCompanyName',
  carrier: 'carrier',
};
export default driver



// WEBPACK FOOTER //
// ./src/page/mdm/driver/lang/driver.en.js